<template>
    <div class="banner">
        <swiper
            :options="swiperOption"
            ref="swiper"
            class="swiper"
            v-if="dataInfo.banner_type == 2"
        >
            <swiper-slide
                v-for="(item, index) in dataInfo.banner_list"
                class="swiper__slide"
                :key="index"
            >
                <img :src="item.image_p" alt="" style="width:100%">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="video" v-if="dataInfo.banner_type == 1">
            <video
                class="video-js"
                id="videoPlayer"
                muted
                autoplay
                playsinline
                loop
                poster="https://appd.knowbox.cn/ss/activity/knowbox-web/img/poster-web.png"
            >
                <source :src="dataInfo.video_url" type="video/mp4" />
            </video>
        </div>
        <div class="cube"></div>
    </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
// require styles
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import videojs from "video.js";
let vm = null;
@Component({
    components: {
        swiper,
        swiperSlide
    }
})
export default class Banner extends Vue {
    swiperOption = {
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        on: {
            // click: function() {
            //      let url: string =
            //         vm.dataInfo.banner_list[
            //             // tslint:disable-next-line
            //             (this as any).realIndex
            //         ].url_p;

            //     if (url === "") {
            //         return;
            //     }
            //     window.open(url);
            // }
        }
    };

    get swiper() {
        return this.$refs.swiper?this.$refs.swiper.swiper:{};
    }

    get dataInfo() {
        const banner_list = this.$store.state.common.banner.banner_list;
        if(banner_list&&banner_list.length===1){
            this.swiperOption.autoplay =false;
        }
        return this.$store.state.common.banner;
    }
    mounted() {
        vm = this;
    }

}
</script>
<style lang="scss">
.banner {
    position: relative;
    .video-js {
        width: 100%;
        z-index: 999;
        outline: 0;
        background: #fff;
        video {
            outline: 0;
        }
    }
    .cube {
        width: 643px;
        height: 643px;
        position: absolute;
        background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/cubex2.png)
            no-repeat;
        background-size: 100% 100%;
        right: -42px;
        bottom: -260px;
        transform: rotate(75deg);
    }
    .swiper {
        &__slide {
            position: relative;
        }
        .swiper-pagination {
            .swiper-pagination-bullet {
                width: 8px;
                height: 8px;
                background: rgba(255, 255, 255, 0.6);
                border-radius: 0;
                &.swiper-pagination-bullet-active {
                    width: 90px;
                    background: #fb5000;
                }
            }
        }
    }
}
</style>
<style lang="css">
@import "../../../node_modules/video.js/dist/video-js.css";
</style>